export const getRandomElementFromArray = (array: any[]) => array[Math.floor(Math.random() * array.length)]

export const isSafeURL = (inputURL) => {
  const url = new URL(inputURL)
  return [`http:`, `https:`].includes(url.protocol)
}